import {
    accentColor,
    activeDotColor,
    challanBlueBg,
    challanSvgAvatarCircleBg,
    challanSvgBillCircleBg,
    challanSvgBillDarkFill,
    challanSvgBillLineStroke,
    challanSvgCancelCircleBg,
    challanSvgDeleteFill,
    challanSvgEditAccentStroke,
    challanSvgExcelAccentFill,
    challanSvgExcelCircleBg,
    closedTextColor,
    grayShade,
    greenShade,
    greenishFade,
    lightYellowFaded,
    metricBlueColor,
    metricGreenColor,
    metricRedColor,
    redDarkShade,
    slightRed,
    tagAmberTextColor,
    tagBlueTextColor,
    tagPurpleTextColor,
    white,
} from "../../../config/ColorObj";
import TypographyCompo from "../../../components/Comman/TypographyCompo";

export const IconRupee = ({ size = 14, color = metricGreenColor }) => (
    <TypographyCompo style={{ fontSize: size, color, lineHeight: 1 }}>₹</TypographyCompo>
);

export const IconStockTransfer = ({
    size = 13,
    strokeWidth = "1.2",
    color = metricBlueColor,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M5 2.5H11L15 6.5V16a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 16V4a1.5 1.5 0 0 1 1-1.5Z" />
        <polyline points="11,2.5 11,6.5 15,6.5" />
        <line x1="6" y1="13" x2="13" y2="13" />
        <polyline points="11.5,11.5 13,13 11.5,14.5" />
        <line x1="13" y1="15.5" x2="6" y2="15.5" />
        <polyline points="7.5,14 6,15.5 7.5,17" />
    </svg>
);

export const CancelIcon = ({ size = 48 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill={challanSvgCancelCircleBg} />
        <circle cx="24" cy="24" r="9" stroke={slightRed} strokeWidth="1.8" />
        <path
            d="M20 20L28 28M28 20L20 28"
            stroke={slightRed}
            strokeWidth="1.8"
            strokeLinecap="round"
        />
    </svg>
);

export const IconPDF = ({ size = 13, strokeWidth = "1.2", color = redDarkShade }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M5 2.5H11L15 6.5V16a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 16V4a1.5 1.5 0 0 1 1-1.5Z" />
        <polyline points="11,2.5 11,6.5 15,6.5" />
        <line x1="6.5" y1="9" x2="12.5" y2="9" />
        <line x1="6.5" y1="11.5" x2="12.5" y2="11.5" />
        <line x1="6.5" y1="14" x2="10.5" y2="14" />
        <rect x="9.5" y="12.5" width="4" height="3" rx="0.6" />
    </svg>
);

export const ChevronIcon = () => (
    <svg
        width="11"
        height="11"
        viewBox="0 0 12 12"
        fill="none"
        stroke={grayShade}
        strokeWidth="2"
        strokeLinecap="round"
    >
        <polyline points="2,4 6,8 10,4" />
    </svg>
);



export const IconUnits = ({ size = 11, color = tagBlueTextColor }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="2" y="5" width="10" height="8" rx="1" />
        <path d="M5 5 V3 Q7 1 9 3 V5" />
    </svg>
);

export const IconProducts = ({ size = 11, color = tagPurpleTextColor }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="1.5" y="1.5" width="4" height="4" rx="0.8" />
        <rect x="8.5" y="1.5" width="4" height="4" rx="0.8" />
        <rect x="1.5" y="8.5" width="4" height="4" rx="0.8" />
        <rect x="8.5" y="8.5" width="4" height="4" rx="0.8" />
    </svg>
);

export const IconClosed = ({ size = 11, color = closedTextColor }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="7" cy="7" r="5.5" />
        <polyline points="4.5,7 6.5,9 9.5,5" />
    </svg>
);

export const IconActive = ({ size = 11, color = tagAmberTextColor }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
    >
        <circle cx="7" cy="7" r="5.5" />
        <polyline points="7,4 7,7 9.5,8.5" />
    </svg>
);

export const IconCollection = ({ size = 11, color = closedTextColor }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="1.5" y="4" width="11" height="8" rx="1.2" />
        <path d="M4 4 V3 Q7 1 10 3 V4" />
        <circle cx="10" cy="8" r="1.2" fill={color} stroke="none" />
    </svg>
);

export const DotIcon = ({ state }) => {
    if (state === "done" || state === "closed")
        return (
            <svg
                width="11"
                height="11"
                viewBox="0 0 12 12"
                fill="none"
                stroke={state === "closed" ? accentColor : greenishFade}
                strokeWidth="2.2"
                strokeLinecap="round"
            >
                <polyline points="2,6 5,9 10,3" />
            </svg>
        );
    if (state === "active")
        return (
            <svg width="7" height="7" viewBox="0 0 8 8">
                <circle cx="4" cy="4" r="3" fill={activeDotColor} />
            </svg>
        );
    if (state === "overdue")
        return (
            <svg
                width="9"
                height="9"
                viewBox="0 0 10 10"
                fill="none"
                stroke={metricRedColor}
                strokeWidth="2"
                strokeLinecap="round"
            >
                <line x1="2" y1="2" x2="8" y2="8" />
                <line x1="8" y1="2" x2="2" y2="8" />
            </svg>
        );
    return (
        <svg width="7" height="7" viewBox="0 0 8 8">
            <circle
                cx="4"
                cy="4"
                r="2.5"
                fill="none"
                stroke={lightYellowFaded}
                strokeWidth="1.5"
            />
        </svg>
    );
};

export const EditIcon = ({ size = 48 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill={challanBlueBg} />
        <path
            d="M28.5 15.5L32.5 19.5L20 32H16V28L28.5 15.5Z"
            fill={accentColor}
            stroke={accentColor}
            strokeWidth="1.2"
            strokeLinejoin="round"
        />
        <path
            d="M26 18L30 22"
            stroke={challanSvgEditAccentStroke}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <path
            d="M16 32H32"
            stroke={accentColor}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export const BillIcon = ({ size = 25 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill={challanSvgBillCircleBg} />
        <rect x="16" y="13" width="16" height="22" rx="2" fill={challanSvgBillDarkFill} />
        <path d="M19 18H29" stroke={challanSvgBillLineStroke} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M19 21.5H29" stroke={challanSvgBillLineStroke} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M19 25H25" stroke={challanSvgBillLineStroke} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M19 28.5H22" stroke={challanSvgEditAccentStroke} strokeWidth="1.4" strokeLinecap="round" />
        <path
            d="M16 34L18.5 31L21 34L23.5 31L26 34L28.5 31L31 34"
            stroke={challanSvgBillDarkFill}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// ─── 4. Delete Icon — Red ───────────────────────────────────────────────────
export const DeleteIcon = ({ size = 25 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill={challanSvgCancelCircleBg} />
        <path d="M17 20H31" stroke={slightRed} strokeWidth="1.8" strokeLinecap="round" />
        <path
            d="M21 20V17H27V20"
            stroke={slightRed}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect x="18.5" y="20" width="11" height="12" rx="1.5" stroke={slightRed} strokeWidth="1.6" fill={challanSvgDeleteFill} />
        <path d="M22 23V29" stroke={slightRed} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M26 23V29" stroke={slightRed} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

// ─── 5. Excel Export Icon — Green ───────────────────────────────────────────
export const ExcelIcon = ({ size = 25 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill={challanSvgExcelCircleBg} />
        <rect x="15" y="13" width="18" height="22" rx="2" fill={greenShade} />
        <rect x="19" y="19" width="4" height="3" rx="0.5" fill={challanSvgExcelAccentFill} opacity="0.6" />
        <rect x="25" y="19" width="4" height="3" rx="0.5" fill={challanSvgExcelAccentFill} opacity="0.6" />
        <rect x="19" y="24" width="4" height="3" rx="0.5" fill={challanSvgExcelAccentFill} opacity="0.6" />
        <rect x="25" y="24" width="4" height="3" rx="0.5" fill={challanSvgExcelAccentFill} opacity="0.6" />
        <path
            d="M20 18L24 24L20 30"
            stroke={white}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M28 18L24 24L28 30"
            stroke={challanSvgExcelAccentFill}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M19 29H29" stroke={white} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

export const UserIcon = ({ size = 42 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle cx="12" cy="12" r="12" fill={challanSvgAvatarCircleBg} />

        <path
            d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
            stroke={white}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        <path
            d="M7 18C7.8 15.8 10 14.5 12 14.5C14 14.5 16.2 15.8 17 18"
            stroke={white}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CalendarIcon = ({ size = 42 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle cx="12" cy="12" r="12" fill={challanSvgAvatarCircleBg} />

        <rect
            x="6"
            y="8"
            width="12"
            height="10"
            rx="2"
            stroke={white}
            strokeWidth="1.2"
        />

        <path
            d="M9 6V10"
            stroke={white}
            strokeWidth="1.2"
            strokeLinecap="round"
        />

        <path
            d="M15 6V10"
            stroke={white}
            strokeWidth="1.2"
            strokeLinecap="round"
        />

        <path
            d="M6 11H18"
            stroke={white}
            strokeWidth="1.2"
        />
    </svg>
);

export const TruckIcon = ({ size = 42 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle cx="12" cy="12" r="12" fill={challanSvgAvatarCircleBg} />

        <path
            d="M6 9H13V15H6V9Z"
            stroke={white}
            strokeWidth="1.2"
            strokeLinejoin="round"
        />

        <path
            d="M13 11H16L18 13V15H13V11Z"
            stroke={white}
            strokeWidth="1.2"
            strokeLinejoin="round"
        />

        <circle
            cx="9"
            cy="16.5"
            r="1.2"
            stroke={white}
            strokeWidth="1.4"
        />

        <circle
            cx="16"
            cy="16.5"
            r="1.2"
            stroke={white}
            strokeWidth="1.4"
        />
    </svg>
);

export const ShieldIcon = ({ size = 42 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle cx="12" cy="12" r="12" fill={challanSvgAvatarCircleBg} />

        <path
            d="M12 6L16 7.5V11C16 14 14 16 12 17.5C10 16 8 14 8 11V7.5L12 6Z"
            stroke={white}
            strokeWidth="1.3"
            strokeLinejoin="round"
        />

        <path
            d="M10.5 11.5L11.5 12.5L13.8 10.2"
            stroke={white}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);